// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SmallAccountMenuButton-cls1___2594259cdd00c86615a{/*!*/}.SmallAccountMenuButton-cls2__e29f43266e88dd6549c3{position:absolute;top:2px;right:-10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SmallAccountMenuButton-cls1___2594259cdd00c86615a",
	"cls2": "SmallAccountMenuButton-cls2__e29f43266e88dd6549c3 SmallAccountMenuButton-cls1___2594259cdd00c86615a"
};
export default ___CSS_LOADER_EXPORT___;
